/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];cc-settings-body[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap}cc-settings-body[_ngcontent-%COMP%]   mat-select[_ngcontent-%COMP%]{max-width:277px}@media (max-width:544px){cc-settings-body[_ngcontent-%COMP%]   mat-select[_ngcontent-%COMP%]{max-width:100%}}"];
export { styles as styles };
